import { format } from 'date-fns';

import { get12HourFromDate, getMeridiem } from './timeUtil';

const DATE_INPUT_MAX_LENGTH = 10;

const SLASH_POSITIONS = [2, 5];

export const formatDateInput = (raw: string): string => {
    const digits = raw.replace(/\D/g, '');
    let result = '';

    for (let index = 0; index < digits.length; index++) {
        if (SLASH_POSITIONS.includes(result.length)) {
            result += '/';
        }

        result += digits[index];
    }

    return result.slice(0, DATE_INPUT_MAX_LENGTH);
};

export const formatToUSFullDate = (date: Date): string => format(date, 'MM/dd/yyyy');

export type DateRangeStrings = { from?: string; to?: string };

export const formatDateRange = (range: { from?: Date; to?: Date }): DateRangeStrings => {
    const { from, to } = range;

    return {
        from: from ? format(from, 'MM/dd/yyyy') : undefined,
        to: to ? format(to, 'MM/dd/yyyy') : undefined
    };
};

export const formatToUSDate = (date: Date): string => format(date, 'MM/dd/yy');

export const formatToUSShortDateTime = (date: Date): string => format(date, 'MM/dd/yy, h:mm aa');

export const formatToUSTime = (date: Date): string => format(date, 'h:mm aa');

export const formatToUSDateTime = (date: Date): string => {
    const options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        hour: '2-digit',
        hour12: true,
        minute: '2-digit',
        month: 'short',
        weekday: 'short'
    };

    return date.toLocaleString('en-US', options);
};

export const formatTo12Hour = (date: Date) => `${get12HourFromDate(date)}${getMeridiem(date)}`;

export const formatToUSDateTimeWith12Hour = (date: Date | string): string => {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    const year = dateObj.getFullYear();
    const hour = get12HourFromDate(dateObj);
    const minute = String(dateObj.getMinutes()).padStart(2, '0');
    const meridiem = getMeridiem(dateObj).toLowerCase();

    return `${month}/${day}/${year} @ ${hour}:${minute}${meridiem}`;
};
